import { User } from 'oidc-client-ts'

type CemIdentityClaims = {
  idp?: string
  amr?: string | string[]
  role?: string | string[]
}

const asList = (value: string | string[] | undefined): string[] =>
  Array.isArray(value) ? value : value ? [value] : []

export function isCemEmployee(user: User | null): boolean {
  if (!user) return false
  const profile = user.profile as CemIdentityClaims
  const isCemByIdp = profile.idp === 'CEM.EmployeeIdentityAdfs' && asList(profile.amr).includes('external')
  const isCemByRole = asList(profile.role).some((role) => role === 'CEM_Employee' || role === 'Admin')

  return isCemByIdp || isCemByRole
}
